module.exports = __webpack_public_path__ + "static/media/savedContBack.c89de657.svg";